export default __webpack_public_path__ + "static/yash-sharma-meshery-maintainer-e3448637cc54fa2ccfaba864d55012ef.png";